import type { ReactNode } from 'react';

/* Compact line-icon set (currentColor). Sports map to the closest glyph. */
const P = {
  star: <><path d="M12 3l2.6 5.3 5.9.9-4.3 4.1 1 5.8L12 16.9 6.8 19.6l1-5.8L3.5 9.7l5.9-.9L12 3z" /></>,
  oval: <><ellipse cx="12" cy="12" rx="9" ry="6" /><path d="M8 9l8 6M16 9l-8 6" /></>,
  globe: <><circle cx="12" cy="12" r="9" /><path d="M3 12h18M12 3c3 3 3 15 0 18M12 3c-3 3-3 15 0 18" /></>,
  ball: <><circle cx="12" cy="12" r="9" /><path d="M12 3v18M3 12h18" /></>,
  disc: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="3.5" /></>,
  eye: <><path d="M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6S2 12 2 12z" /><circle cx="12" cy="12" r="2.6" /></>,
  flag: <><path d="M6 21V4M6 4h11l-2 4 2 4H6" /></>,
  puck: <><ellipse cx="12" cy="13" rx="7" ry="3" /><path d="M5 10v3M19 10v3" /></>,
  gloves: <><path d="M7 20v-6a4 4 0 0 1 8 0v6M9 12V8a2 2 0 1 1 4 0" /></>,
  horse: <><path d="M4 20c1-6 4-9 9-9l3-3 2 1-1 3c2 2 2 5 2 8" /></>,
  bike: <><circle cx="6" cy="17" r="3" /><circle cx="18" cy="17" r="3" /><path d="M6 17l4-7h5l3 7M10 10l2-4h3" /></>,
  target: <><circle cx="12" cy="12" r="9" /><circle cx="12" cy="12" r="5" /><circle cx="12" cy="12" r="1.5" /></>,
  paddle: <><circle cx="10" cy="9" r="5" /><path d="M13 13l5 6" /></>,
  chip: <><rect x="4" y="7" width="16" height="10" rx="2" /><path d="M9 7v10M15 7v10" /></>,
  net: <><path d="M4 8h16M4 12h16M4 16h16M8 8v8M12 8v8M16 8v8" /></>,
} satisfies Record<string, ReactNode>;

export interface SportCat {
  id: string;
  name: string;
  live?: boolean;
  icon: ReactNode;
}

/* The 27 categories from the prototype (Sportsbet-AU coverage). */
export const SPORTS: SportCat[] = [
  { id: 'afl', name: 'AFL', live: true, icon: P.star },
  { id: 'nrl', name: 'NRL', icon: P.oval },
  { id: 'rugby', name: 'Rugby Union', icon: P.oval },
  { id: 'soccer', name: 'Soccer', icon: P.globe },
  { id: 'nba', name: 'NBA', icon: P.ball },
  { id: 'nbl', name: 'NBL', icon: P.ball },
  { id: 'nfl', name: 'NFL', icon: P.eye },
  { id: 'mlb', name: 'MLB', icon: P.disc },
  { id: 'cricket', name: 'Cricket', live: true, icon: P.disc },
  { id: 'tennis', name: 'Tennis', icon: P.paddle },
  { id: 'golf', name: 'Golf', icon: P.flag },
  { id: 'nhl', name: 'NHL', icon: P.puck },
  { id: 'ufc_mma', name: 'UFC / MMA', icon: P.target },
  { id: 'boxing', name: 'Boxing', icon: P.gloves },
  { id: 'horse_racing', name: 'Horse Racing', live: true, icon: P.horse },
  { id: 'greyhounds', name: 'Greyhounds', icon: P.horse },
  { id: 'harness', name: 'Harness', icon: P.horse },
  { id: 'motor', name: 'Motor Racing', icon: P.bike },
  { id: 'cycling', name: 'Cycling', icon: P.bike },
  { id: 'darts', name: 'Darts', icon: P.target },
  { id: 'snooker', name: 'Snooker', icon: P.disc },
  { id: 'tabletennis', name: 'Table Tennis', icon: P.paddle },
  { id: 'volleyball', name: 'Volleyball', icon: P.net },
  { id: 'handball', name: 'Handball', icon: P.ball },
  { id: 'gaa', name: 'GAA', icon: P.disc },
  { id: 'esports', name: 'eSports', icon: P.chip },
];
